import { render, staticRenderFns } from "./AttributePanel.vue?vue&type=template&id=5d6175db"
import script from "./AttributePanel.vue?vue&type=script&lang=js"
export * from "./AttributePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports